import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tpl-feedback',
  templateUrl: './tpl-feedback.component.html',
  styleUrls: ['./tpl-feedback.component.sass']
})
export class TplFeedbackComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() btnSubmit: string;

  @Output() nextStep = new EventEmitter<string>();
  @Output() hiddenShowTitle = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
    
  }

  openForm(button_area, text_area) {
    text_area.style.display = "block";
    button_area.style.display = "none";
    this.hiddenShowTitle.emit(false);
  }
  
  closeForm(button_area, text_area) {
    text_area.style.display = "none";
    button_area.style.display = "flex";
    this.hiddenShowTitle.emit(true);
  }

  finishQuestion() {
    this.nextStep.emit('')
  }

}
